module.exports = __webpack_public_path__ + "static/img/logo.921ea56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 99